export default __webpack_public_path__ + "static/traits-612223cd217bae49cb04543e57d1f91b.svg";